import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";

const defaultState = {};

function CRITERION_EDITORS_SET(state, action) {
	const { criteria } = action;
	const nextState = { ...state };
	Object.keys(criteria).forEach(name => {
		nextState[name] = {
			...criteria[name],
			type: criteria[name].type.toUpperCase(),
		};
	});

	return nextState;
}

const handlers = {};
handlers[actionTypes.CRITERION_EDITORS_SET] = CRITERION_EDITORS_SET;
export default createReducer(defaultState, handlers);
